<template>
  <v-container grid-list-md fluid>
    <v-layout wrap>
      <v-flex v-for="channel in channels" :key="channel.id" xs12 sm6 md4 lg3>
        <channel-card :channel="channel" class="pa-2" />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import ChannelCard from "@/components/global/ChannelCard";
export default {
  name: "ChannelWidget",
  components: {
    ChannelCard
  },
  props: {
    channels: {
      type: Array,
      default: null
    }
  }
};
</script>
